import React, { useContext } from "react";
import { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { ConfigContext } from "../../Context/ConfigContext";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { ContentLoader } from "../../Components/Shimmer";

const ActiveProjects = () => {

  const [activeProjects, setActiveProjects] = useState([])
  const { project_id } = useParams()
  const [loadingList, setLoadingList] = useState(false);

  const { apiURL, apiHeaderJson, user_profile_id, user_id } = useContext(ConfigContext);

  const getActiveProjects = async () => {
    try {
      setLoadingList(true)
      const headers = apiHeaderJson;
      const response = await axios.get(`${apiURL}api/consultants/projects/${user_profile_id}`)
      const { data, success } = response.data;
      if (success) {
        const activeOnly = data.filter(project => project.project_status === 0);
        setActiveProjects(activeOnly);
      }

    } catch (error) {
      console.log(error);

    }
    finally {
      setLoadingList(false)
    }
  }

  const GetStatus = (status) => {
    if (status == '0') {
      return "Active"
    } else if (status == '1') {
      return "Completed"
    } else if (status == '2') {
      return "Cancelled"
    }
  }


  const GetBadge = (status) => {
    if (status == '0') {
      return "badge bg-info-subtle text-info"
    } else if (status == '1') {
      return "badge bg-success-subtle text-success"
    } else if (status == '2') {
      return "badge bg-warning-subtle text-warning"
    }

  }

  useEffect(() => {
    getActiveProjects();
  }, [])

  return (
    <>
      <div className="card-header align-items-center d-flex">
        <h4 className="card-title mb-0 flex-grow-1">Active Project </h4>
      </div>


      {
        loadingList ? <ContentLoader /> :
          <>
            <div
              data-simplebar="init"
              style={{ height: '70vh' }}
              className="simplebar-scrollable-y"
            >
              <div className="simplebar-wrapper" style={{ margin: 0 }}>
                <div className="simplebar-height-auto-observer-wrapper">
                  <div className="simplebar-height-auto-observer" />
                </div>
                <div className="simplebar-mask">
                  <div className="simplebar-offset" style={{ right: 0, bottom: 0 }}>
                    <div
                      className="simplebar-content-wrapper"
                      tabIndex={0}
                      role="region"
                      aria-label="scrollable content"
                      style={{ height: "auto", overflow: "hidden scroll" }}
                    >
                      <div className="simplebar-content" style={{ padding: 0 }}>
                        {activeProjects.length !== 0 ? (
                          activeProjects.map((item, index) => (
                            <div className={`list-group ${index === 0 ? '' : ' mt-3'} px-3`} key={index}>
                              <Link to={`/ProjectProfile/${item?.project_id}`} className="list-group-item list-group-item-action mt-3">
                                <div className="float-end">
                                  <span className={GetBadge(item.project_status)}>{GetStatus(item.project_status)}</span>
                                </div>
                                <div className="d-flex mb-2 align-items-center">
                                  <div className="flex-shrink-0">
                                    <img
                                      src={`https://napp.newlinesgroup.com/apis/api/project-logo/${item.project_logo}`}
                                      alt="Project Logo"
                                      className="avatar-sm rounded-circle"
                                      onError={(e) => {
                                        console.log("Image failed to load:", e);
                                        e.target.src = "https://contractor.atctransline.in/assets/images/users/Noicon.jpeg";
                                      }}
                                      onLoad={() => console.log("Image loaded successfully")}
                                    />
                                  </div>
                                  <div className="flex-grow-1 ms-3">
                                    <h5 className="list-title fs-15 mb-1">{item.project_title}</h5>
                                    <p className="list-text mb-0 fs-12">{item.client_name}</p>
                                  </div>
                                </div>
                                <div className="row mb-3 mt-3">
                                  <div className="col-12 col-md-12">
                                    <div className="d-flex">
                                      <div className="flex-shrink-0 avatar-xs align-self-center me-3">
                                        <div className="avatar-title bg-light rounded-circle fs-16 text-dark">
                                          <i className="ri-profile-line" />
                                        </div>
                                      </div>
                                      <div className="flex-grow-1 overflow-hidden">
                                        <p className="mb-1">About Project :</p>
                                        <h6 className="text-truncate">
                                          <a href="#" className="fw-semibold text-dark">{item.project_description}</a>
                                        </h6>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-12">
                                    <div className="d-flex">
                                      <div className="flex-shrink-0 avatar-xs align-self-center me-3">
                                        <div className="avatar-title bg-light rounded-circle fs-16 text-dark">
                                          <i className="ri-map-pin-line" />
                                        </div>
                                      </div>
                                      <div className="flex-grow-1 overflow-hidden">
                                        <p className="mb-1">Location :</p>
                                        <a href="#" className="fw-semibold text-dark">{item.project_address}</a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          ))
                        ) : (
                          <div className="d-flex justify-content-center align-items-center" style={{ height: '60vh' }}>
                            <h3 className="text-muted">No Data Found...!</h3>
                          </div>
                        )}
                      </div>

                    </div>
                  </div>
                </div>
                <div
                  className="simplebar-placeholder"
                  style={{ width: 358, height: 303 }}
                />
              </div>
              <div
                className="simplebar-track simplebar-horizontal"
                style={{ visibility: "hidden" }}
              >
                <div
                  className="simplebar-scrollbar"
                  style={{ width: 0, display: "none" }}
                />
              </div>
              <div
                className="simplebar-track simplebar-vertical"
                style={{ visibility: "visible" }}
              >
                <div
                  className="simplebar-scrollbar"
                  style={{
                    height: 152,
                    transform: "translate3d(0px, 0px, 0px)",
                    display: "block"
                  }}
                />
              </div>
            </div>
          </>
      }

    </>
  );
};

export default ActiveProjects;
